module.exports = __webpack_public_path__ + "static/img/2014@2x.aad7561.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/newEvents/2014@2x.png
// module id = L5uw
// module chunks = 1